// extracted by mini-css-extract-plugin
export default {"root":"TabSelector_root__rc2Q2","tab":"TabSelector_tab__H7M24","activeTab":"TabSelector_activeTab__kx4Sf"};